
/*
 * Pure helpers and constants for the Dashboard's cards: no state, no data fetching.
 * Times are unix seconds; IST is the farm's clock.
 */

export const IST = 19800;
export const DAY = 86400;

export function ago(ts, now) {
  if (!ts) return 'never';
  const s = Math.max(0, now - ts);
  if (s < 90) return 'just now';
  if (s < 3600) return `${Math.round(s / 60)} min ago`;
  if (s < DAY) return `${Math.floor(s / 3600)} h ago`;
  return `${Math.floor(s / DAY)} d ago`;
}

export const plural = (n, word, many = `${word}s`) => `${n} ${n === 1 ? word : many}`;

// "08:15", IST: the timeline's time column, fixed width so the rail lines up.
export const hhmm24 = ts => new Date((ts + IST) * 1000).toISOString().slice(11, 16);

// Colour with alpha from a theme hex, so chips and fills follow light/dark mode.
export const alpha = (hex, a) => {
  const h = String(hex).replace('#', '');
  const n = parseInt(h.length === 3 ? h.split('').map(c => c + c).join('') : h, 16);
  return `rgba(${(n >> 16) & 255}, ${(n >> 8) & 255}, ${n & 255}, ${a})`;
};

/* ------------------------------------------------------------------ plants */

// "421 of 487 establishing": the stage as what the plants are doing now.
export const STAGE_NOW = { establishment: 'establishing', planting: 'establishing', harvest: 'at harvest' };


// The rack row's right column: the furthest-along count in words ("9 flowers" over "19 buds"),
// since two counts in words would squeeze the bars and the Plant Log's "bd / fl" tags read as
// code here. The row's tooltip carries every count.
export const bloomTag = ({ buds = 0, flowers = 0, fruit = 0 }) => {
  if (fruit > 0) return `${fruit} fruit`;
  if (flowers > 0) return plural(flowers, 'flower');
  if (buds > 0) return plural(buds, 'bud');
  return 'No buds';
};


// Plant health's bar segments and key: count key on `crop`, theme colour, label.
export const HEALTH_PARTS = [['healthy', 'success', 'Healthy'], ['stressed', 'warning', 'Stressed'], ['unhealthy', 'danger', 'Unhealthy']];

export const STAGE_SHORT = {
  establishment: 'Est', vegetative: 'Veg', budding: 'Bud', flowering: 'Flower', fruiting: 'Fruit', harvest: 'Harvest',
};

/* ------------------------------------------------------------------ trends */

// Change over a lookback: the newest reading against the one nearest `back`
// seconds before it. Null when there is not enough history to say.
export const trendOf = (pts, back) => {
  const valid = (pts || []).filter(p => p.v != null);
  if (valid.length < 2) return null;
  const last = valid[valid.length - 1];
  const ref = [...valid].reverse().find(p => p.t <= last.t - back);
  if (!ref || last.t - ref.t > back * 1.6) return null;
  return { delta: last.v - ref.v, since: ref.t };
};
